 <template>
  <el-row class="el-row_h">
    <el-col :span="24">
      <div class="grid-content bg-purple-dark layout_box flex s_bg" style="overflow: auto;">
        <el-input style="min-width: 150px;" placeholder="请输入关键字搜索" v-model="keyWord" clearable size="small" class="s_padding filterSelect">
        </el-input>
        <el-button type="primary" icon="el-icon-search" size="small" @click="getList()">查询</el-button>
      </div>
      <div style="height:100%">
        <tableCom :data="delegateList" v-loading="loading"></tableCom>
      </div>
      <div class="pagination_mb2 text-center">
        <pagination :pagerPro="Pager" @ee="pageFn"></pagination>
      </div>
      <div class="footer grid-content bg-purple layout_box">
        <span class="text-right">
          佣金合计:
          <span class="capital">{{totalCapital}}</span>
          <span class="Currency"> ({{CurrencyName}})</span>
          &nbsp;&nbsp;&nbsp; 成交总量:
          <span class="capital">{{totalDeal}}</span>
          <span class="Currency"> (手)</span>
          &nbsp;&nbsp;&nbsp; 平仓盈亏:
          <span class="capital">{{closeProfit}}</span>
          <span class="Currency"> ({{CurrencyName}})</span>
        </span>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import tableCom from "./mydealDetailT.vue";
import pagination from "../../paging.vue";

export default {
  // 筛选器
  name: "positionDetailS",
  components: {
    tableCom,
    pagination
  },
  props: ["agentID"],
  data() {
    return {
      loading: "",
      Pager: {
        PageNo: 1,
        PageSize: 10,
        RecordCount: 0
      },
      delegateList: [],
      totalCapital: 0,
      totalCurrency: 0,
      totalDeal: 0,
      closeProfit: 0,
      PositionEffectValue: "",
      PositionEffectList: [
        { Code: 0, Name: "请选择" },
        { Code: 1, Name: "开仓" },
        { Code: 2, Name: "平仓" }
      ],
      keyWord: "",
      CurrencyName: '',
    };
  },
  mounted() {
    this.PositionEffectValue = this.PositionEffectList[0].Code;
    this.getList();
    this.getCurrencyName();
  },
  methods: {
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    getList(isSearch = true) {
      if (isSearch) {
        this.Pager = {
          PageNo: 1,
          PageSize: 20,
          RecordCount: 0
        };
      }
      this.$emit("mydealDetail", this.keyWord);
      this.loading = true;
      let url = "/mycustomer/QryInsUserCurrentTrade";
      let postData = {
        AgentIds: this.agentID,
        UserKey: this.keyWord
      };
      this.$loginapi.postWithPage(
        url,
        this.Pager.PageNo,
        this.Pager.PageSize,
        postData,
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            this.delegateList = response.Data.Records;
            this.totalCapital = response.Data.Commission;
            this.closeProfit = response.Data.CloseProfit;
            this.totalDeal = response.Data.Volume;

            if (this.Pager.PageNo == 1) {
              this.Pager = response.Pager;
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    pageFn(size, PageNo) {
      this.Pager.PageSize = size;
      this.Pager.PageNo = PageNo;
      this.getList(false);
    }
  }
};
</script>

<style scoped>
.pagination_m {
}
</style>



// WEBPACK FOOTER //
// src/components/selects/mydealDetail/mydealDetailS.vue